import React from 'react';
import './BackgroundDecoration.css';

/**
 * BackgroundDecoration - Componente para renderizar imágenes decorativas de fondo
 * @param {string} image - Ruta de la imagen
 * @param {string} position - Posición: 'top-left', 'top-right', 'bottom-left', 'bottom-right'
 * @param {number} rotation - Grados de rotación (0, 90, 180, 270)
 * @param {number} size - Tamaño en px (desktop)
 * @param {number} opacity - Opacidad (0-1)
 */
const BackgroundDecoration = ({ image, position = 'top-right', rotation = 0, size = 180, opacity = 0.15 }) => {
  if (!image) return null;

  const positionClasses = {
    'top-left': 'bg-decoration--top-left',
    'top-right': 'bg-decoration--top-right',
    'bottom-left': 'bg-decoration--bottom-left',
    'bottom-right': 'bg-decoration--bottom-right'
  };

  const positionClass = positionClasses[position] || positionClasses['top-right'];

  return (
    <img
      src={image}
      alt=""
      className={`bg-decoration ${positionClass}`}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        opacity: opacity,
        transform: `rotate(${rotation}deg)`
      }}
      aria-hidden="true"
    />
  );
};

export default BackgroundDecoration;
